import { useField } from 'formik';
import React from 'react';
import { TextInput, TextInputProps } from './TextInput';

export const TextInputField = (props: TextInputProps) => {
  const [field, { error }, { setError }] = useField({
    id: props.id,
    name: props.name,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    setError('');
  };

  return (
    <TextInput
      {...props}
      error={error || props.error}
      id={field.name}
      {...field}
      value={props.value ?? field.value ?? ''}
      onChange={props.onChange || handleChange}
    />
  );
};
